import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import StyledSelect from "core/components/fields/styledSelect";
import Dropzone from 'react-dropzone';
import MdField from 'core/metamodel/mdField';
import {createForm} from 'core/form/createForm';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {MdIconButton} from "core/components/buttons/icons";
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {FieldText, FormProps, ClosedContentProps} from 'core/form/formUtils'
import documentService from "core/document/documentService";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import Add from "material-ui/svg-icons/content/add";
import {LoadingElement} from "core/components/common/loading";
import {observer} from "mobx-react";
import {VALUESOURCETYPE} from "core/metamodel/mdField";
import {DATATYPE} from "core/metamodel/mdField";
import {DocumentTemplate, DocumentTemplateResource} from "core/document/documentDomain";
import {ObservableMap, action, observable} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {ActivityTemplate, EventTemplate} from "core/event/eventDomain";


interface DocumentTemplateResourceListProps {
  documentTemplateObject: DocumentTemplate | EventTemplate | ActivityTemplate;
  entities: ObservableMap<MdEntity>;
  showType: boolean;

}

@observer
export default class DocumentTemplateResourceList extends React.Component<DocumentTemplateResourceListProps, undefined> {

  _dropzone: any;


  onOpenDropzone = () => {
    this._dropzone.open();
  };


  @action onDrop = (files: File[]) => {
    console.log('onDrop ', files);
    this.props.documentTemplateObject.$loading = true;
    let promiseArray = files.map(file => documentService.loadFile(file));
    Promise.all(promiseArray).then(resultArray => {
      for(let resource of resultArray) {
        this.props.documentTemplateObject.resources.set(resource.name, resource);
      }
      this.props.documentTemplateObject.$dirty = true;
      this.props.documentTemplateObject.$loading = false;
    }, err => {
      this.props.documentTemplateObject.$loading = false;
    });
  };


  render() {

    const {documentTemplateObject, entities, showType} = this.props;

    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>Resources</div>
        <MdIconButton onClick={this.onOpenDropzone}>
          <Add />
        </MdIconButton>
      </div>
    );


    return (
      <BlockComp  noPadding={true} header={header} style={{display: 'flex', flexDirection: 'column'}}>

        {(documentTemplateObject.$loading) ? <LoadingElement/> : null}

      <Dropzone ref={c => this._dropzone = c} onDrop={this.onDrop} style={{display:'none'}}/>

        {
          addSeparator( documentTemplateObject.resources.entries()
            .sort( (a, b) => a[0].localeCompare(b[0]) )
            .map((pair, index, array) => < DocumentTemplateResourceForm dataObject={pair[1]}  rootObject={documentTemplateObject} key={index}
                                                                         entities={entities} entity={entities.get('DocumentTemplateResource')}
                                                                          index={index} showType={showType} /> ), <MdDivider inset/>)
        }

      </BlockComp>
    );
  }
}


interface DocumentTemplateResourceFormProps extends FormProps<DocumentTemplateResource, DocumentTemplate|EventTemplate|ActivityTemplate> {
  showType: boolean;
}


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<DocumentTemplateResource>) => (
  <div style={{fontSize: 14, lineHeight: '14px', minHeight: 20}}>
    <a href={"data:" + dataObject.contentType + ";base64," + dataObject.content} target="_blank" style={{marginRight: 10}}>{dataObject.name}</a>
    <FieldText label={fields.size.textLabel} value={dataObject.size} mdField={fields.size.mdField}/>
    <FieldText label={fields.contentType.textLabel} value={dataObject.contentType}/>
    <FieldText label={fields.lastModified.textLabel} value={dataObject.lastModified} mdField={fields.lastModified.mdField}/>
    <FieldText label={fields.type.textLabel} value={dataObject.type}/>
    <FieldText label={fields.qualifyExpression.textLabel} value={dataObject.qualifyExpression}/>
  </div>
);

@createForm({
  formName: ' DocumentTemplateResourceForm',
  closedOnNew: true,
  fields: [{
    name: 'name',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Name', dataType: DATATYPE.STRING })
  }, {
    name: 'contentType',
    mdField: new MdField({label: 'Type', dataType: DATATYPE.STRING })
  }, {
    name: 'lastModified',
    mdField: new MdField({label: 'File timestamp', dataType: DATATYPE.DATETIME })
  }, {
    name: 'type',
    mdField: new MdField({label: 'Usage', valueSource: 'DOCUMENTTEMPLATERESOURCETYPE', valueSourceType: VALUESOURCETYPE.LOCAL })
  }, {
    name: 'size',
    mdField: new MdField({label: 'Size', dataType: DATATYPE.NUMBER })
  }, {
    name: 'qualifyExpression',
    mdField: new MdField({label: 'Qualify Expression', dataType: DATATYPE.STRING })
  }]
}, ClosedContent)
@observer
class  DocumentTemplateResourceForm extends React.Component<DocumentTemplateResourceFormProps, undefined> {

  onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);

    this.props.rootObject.resources =
    this.props.rootObject.resources.values().reduce<ObservableMap<DocumentTemplateResource>>((acc, resource) => {
      if (resource !== this.props.dataObject) {
        acc.set(resource.name, resource);
      }
      return acc;
    }, observable.map<DocumentTemplateResource>());
  };


  render() {
    const {dataObject, rootObject, index, entities, showType, formName, entity} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, lastModified, size, contentType, type, qualifyExpression} = fields;


    const openContent = (
      <div>
        <div>
            <MdTextField {...name.props}/>
            <Validate field={name} value={name.props.value}/>
        </div>
        {showType ?
          <div>
            <StyledSelect {...type.props}/>
          </div>
          : null
        }
        <div>
          <MdTextField {...qualifyExpression.props}/>
        </div>

      </div>
    );


    let {showType: showTypeRenamed, ...activeItemProps} = this.props;

    return (
      <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} key={index} onDelete={this.onDelete} {...activeItemProps} />
    );
  }
}






// WEBPACK FOOTER //
// ./src/core/document/component/documentTemplateResourceList.tsx